<script>
	import { getContext, onMount } from 'svelte'
	import DraggableComponent from '@Components/DraggableComponent.svelte'
	import { on } from 'svelte/events'
	import LoadingIndicator from '@Components/LoadingIndicator.svelte'
	let { visible = false, hasActiveFilter = $bindable(false) } = $props()
	let isLoading = $state(false)
	const { getEditorCanvas, isDev, getController } = getContext('editor')
	const controller = getController()
	const subscription = controller.getSubscription()
	const subscriptionFilter = ['premium']

	const basicDisabled = !subscriptionFilter.includes('premium')
	let canvas = getEditorCanvas()
	async function readSurroundingsData(contents) {
		controller.lockInterfaceWhileSavingHoles();
		await controller.save(false, true);
		isLoading = true
		try {
			let data = JSON.parse(contents)
			// check if data is string
			if (typeof data === 'string') {
				data = JSON.parse(data)
			}
			// check if data is an object
			if (typeof data !== 'object') {
				throw new Error('Invalid data format')
			}
			if (data.result) {
				data = JSON.parse(data.result)
			}
			let url = controller.getUrl('mapping/updatecoursesurroundings')
			let body = JSON.stringify({
				date: Date.now(),
				courseFrames: data.courseFrames,
				settings: data.settings,
				json: data.json
			})
			let [res, err] = await controller.put(url, body)
			if (err) {
				window.dispatchError({
					type: 'error',
					message: 'Error updating hole',
					error: err
				})
				controller.lockInterfaceWhileSavingHoles("Error while updating holes")
			} else {
				window.location.reload()
			}
		} catch (error) {
			window.dispatchError({
				type: 'error',
				message: 'Error importing surroundings',
				error: error
			})
		}
		isLoading = false
	}
	async function readHoleData(contents) {
		isLoading = true
		controller.lockInterfaceWhileSavingHoles();
		try {
			let data = JSON.parse(contents)
			if (typeof data === 'string') {
				data = JSON.parse(data)
			}
			if (typeof data !== 'object') {
				throw new Error('Invalid data format')
			}
			if (data.result) {
				for (const holeGroup of data.result) {
					var oldHoleGroup = controller.data.groups.find((group) => group.name == holeGroup.name && group.shortName == holeGroup.shortName && group.holes.length == holeGroup.holes.length)
					if (!oldHoleGroup) {
						console.log('Hole group not found', holeGroup.name, holeGroup.shortName)
						continue
					}

					for (const hole of holeGroup.holes) {
						var oldHole = oldHoleGroup.holes.find((h) => h.holeNumber == hole.holeNumber && h.par == hole.par)
						if (!oldHole) {
							console.log('Hole not found', hole.holeNumber)
							controller.lockInterfaceWhileSavingHoles(`A hole was not found ${hole.holeNumber} in group ${oldHoleGroup.name} (${oldHoleGroup.shortName})`)
							break;
						}
						let body = {
							holeGroupId: oldHoleGroup.holeGroupId,
							holeId: oldHole.id,
							geometry: hole.geometry,
							surroundings: hole.surroundings,
							greenPoints: hole.greenPoints,
							teePoints: hole.teePoints
						}
						let url = controller.getUrl('mapping/updatehole')
						let [res, err] = await controller.put(url, body)
						if (err) {
							window.dispatchError({
								type: 'error',
								message: 'Error updating hole',
								error: err
							})
							controller.lockInterfaceWhileSavingHoles("Error while updating holes")
							return
						} else {
							console.log('Hole updated', res)
						}
					}
				}
			}
		} catch (error) {
			window.dispatchError({
				type: 'error',
				message: 'Error importing holes',
				error: error
			})
		}
		isLoading = false
		window.location.reload()
	}
	function importHoles() {
		// open json file from input
		const input = document.createElement('input')
		input.type = 'file'
		input.accept = '.json'
		input.onchange = (e) => {
			const file = e.target.files[0]
			if (!file) return
			const reader = new FileReader()
			reader.onload = (e) => {
				if (!confirm('Are you sure you want to import holes? This will replace all current hole data.')) {
					return
				}
				const contents = e.target.result
				if (contents) {
					readHoleData(contents)
				}
			}
			reader.readAsText(file)
		}
		input.click()
	}
	function importSurroundings() {
		// open json file from input
		const input = document.createElement('input')
		input.type = 'file'
		input.accept = '.json'
		input.onchange = (e) => {
			// confirm
			if (!confirm('Are you sure you want to import surroundings? This will replace all current surroundings.')) {
				return
			}
			const file = e.target.files[0]
			if (!file) return
			const reader = new FileReader()
			reader.onload = (e) => {
				const contents = e.target.result
				if (contents) {
					readSurroundingsData(contents)
				}
			}
			reader.readAsText(file)
		}
		input.click()
	}
	onMount(() => {})
</script>

<DraggableComponent initialY="60" yAlignment="bottom" xAlignment="right" closable={true} bind:visible>
	<div class="flex text-sm flex-col text-left pt-0">
		<div class="text-left w-full font-bold p-2 pt-0 select-none">Import data</div>
		<div class="flex text-sm flex-col gap-2 bg-neutral-200 dark:bg-bigsteel-900/20 p-2 list">
			<button
				name="edit"
				tooltip="Press to import and replace surroundings"
				class="btn btn-sm"
				disabled={isLoading}
				class:btn-solid-blue={!isDarkMode}
				class:btn-solid-white={isDarkMode}
				onclick={() => {
					importSurroundings()
				}}>Surroundings</button
			>
			<button
				name="edit"
				tooltip="Remove all filters"
				class="btn btn-sm"
				disabled={isLoading}
				class:btn-solid-blue={!isDarkMode}
				class:btn-solid-white={isDarkMode}
				onclick={() => {
					importHoles()
				}}>Holes</button
			>
			<LoadingIndicator {isLoading} hideWhenIdle={true} color="white" />
		</div>
	</div>
</DraggableComponent>

<style lang="postcss">
	.list {
		width: 160px;
		min-height: 200px;
		max-height: calc(100vh - 640px);
		overflow-y: auto;
	}
</style>
